const state = {
  userList: [],
  userInfoMap: {},
}
const mutations = {
  USERLIST_ADD_USER_LIST_AFTER_LOGIN(state, data) {
    if (data == null) {
      state.userList = [];
      state.userInfoMap = {};
      return;
    }
    for (let index = 0; index < data.length; index++) {
      if (!state.userInfoMap[data[index].uid]) {
        state.userList.push(data[index]);
      }
    }
    for (let index = 0; index < data.length; index++) {
      state.userInfoMap[data[index].uid] = data[index];
    }
    state.userList.sort(function (a, b) {
      if (a.skey < b.skey) {
        return -1;
      } else if (a.skey > b.skey) {
        return 1;
      } else {
        return 0;
      }
    })
  },
  USERLIST_INSERT_ROBOT_INFO(state, data) {
    for (let index = 0; index < array.length; index++) {
      const element = data[index];
      state.userList.push(element);
    }
  },
  USERLIST_REMOVE_USER_INFO(state, uid) {
    var newArray = [];
    for (let index = 0; index < state.userList.length; index++) {
      if (state.userList[index].uid == uid) {
        continue;
      }
      newArray.push(state.userList[index]);
    }
    state.userList = newArray.slice();
    state.userInfoMap[uid] = null;
  }
}

// this message is similar to post message. It's async
const actions = {
  userList_update_user_info({
    commit
  }, data) {
    commit('USERLIST_UPDATE_USER_INFO', data)
  }
}
const getters = {
  getUserInfoByID: (state) => (id) => {
    let b = state.userInfoMap[id];
    if (b == null) {
      b = state.userList.find((e) => (e.id == id))
    }
    return b
  },
}
export default {
  state,
  mutations,
  actions,
  getters
}